module.exports = __webpack_public_path__ + "img/知识库@3x.dea2dda2.png";